import React from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css';

function App() {
  const marketingUrl = process.env.REACT_APP_MARKETING_URL || 'https://forge-io.com';

  return (
    <div className="App">
      <Navbar />
      <main className="main-content">
        <section className="hero">
          <h1>Forge</h1>
          <p>Build custom automations to scale your business.</p>
          <div className="hero-actions">
            <a className="hero-button primary" href={`${marketingUrl}/contact`}>
              Contact
            </a>
            <a className="hero-button" href={`${marketingUrl}/services`}>
              Services
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default App;